import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SmoothScroll = ({ top }) => {
    const { pathname } = useLocation();
    useEffect(() => {
        top.current.scrollIntoView({ behavior: "smooth" })
    }, [pathname , top]);
}
export default SmoothScroll;